import React, { useState, useEffect } from 'react';
import { getDownQualityPicture } from '../../../apicalls/cloud/cloudPicture';
import { checkResData } from '../../../utils/common';
import { useSnackbar } from 'notistack';
import { TLedgerPictur } from '../../../types/Ledger';
import { COLOR_LIGHT_GRAY } from '../../../const/Const';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Checkbox } from '@material-ui/core';
import { updateRotatePicture } from '../../../apicalls/ledger';
import { Button } from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { progressFlgState } from '../../../GlobalState';

type Tprops = {
  item: TLedgerPictur;
  index: number;
  register: any;
  setValue: any;
  imageData: TLedgerPictur[];
  errors: any;
};

export const ImageItem: React.FC<Tprops> = (props: Tprops) => {
  const { item, index, register, setValue, imageData, errors } = props;
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);

  // リクエスト結果のメッセージ
  const { enqueueSnackbar } = useSnackbar();

  const [src, setSrc] = useState<string>();

  useEffect(() => {
    setValue(`pictures.${index}.sort_order`, index + 1);
    setSrc(undefined);
    getDownQualityPicture(item.picture_id).then(resData => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        if (!data) return;
        const imageData = (data.data_for_display ?? data.data).replace(
          /^.*,/,
          ''
        );
        const fileFormat = data.file_format_for_display ?? data.file_format;
        setSrc(`data:${fileFormat};base64,${imageData}`);
        setValue(
          `pictures.${index}.picture_src`,
          `data:${fileFormat};base64,${imageData}`
        );
      });
    });
  }, [item]);

  const onDelete = () => {
    const cloneImageData: TLedgerPictur[] = _.cloneDeep(imageData);
    const index = cloneImageData.findIndex(
      picture => picture.picture_id == item.picture_id
    );
    if (index != -1) {
      cloneImageData.splice(index, 1);
    }
    setValue('pictures', cloneImageData);
  };

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const handleRotateClick = async () => {
    // ローディング開始
    setProgressFlg(true);
    const pictureId = item.picture_id;
    updateRotatePicture(pictureId, 90)
      .then(async () => {
        // updateRotatePictureが成功した後にgetDownQualityPictureを呼び出す
        const resData = await getDownQualityPicture(pictureId);
        const data = await checkResData(resData, enqueueSnackbar);
        if (data) {
          // const image_data = data.data.replace(/^.*,/, '');
          const imageData = (data.data_for_display ?? data.data).replace(
            /^.*,/,
            ''
          );
          const fileFormat = data.file_format_for_display ?? data.file_format;
          setSrc(`data:${fileFormat};base64,${imageData}`);
          setValue(
            `pictures.${index}.picture_src`,
            ` data:${fileFormat};base64,${imageData}`
          );
        }
      })
      .catch(err => {
        console.error('画像の回転に失敗しました。', err);
      })
      .finally(() => {
        // ローディング終了
        setProgressFlg(false);
      });
  };

  return (
    <div
      style={{
        margin: '5px 5px 25px 25px',
        borderTop: index == 0 ? '' : `solid 1px ${COLOR_LIGHT_GRAY}`,
        backgroundColor: '#ffffff'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {/* 閉じるボタン */}
        <div
          style={{
            width: '100%',
            marginRight: 10,
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
            color: '#808080',
            fontSize: 20
          }}
          onClick={onDelete}
        >
          <span>×</span>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: isSmDownScreen ? 'row' : 'column',
            marginLeft: 10
          }}
        >
          {/*  */}

          <div
            style={{
              width: isSmDownScreen ? '40%' : '80%',
              height: 'auto',
              display: 'grid',
              placeItems: 'center'
            }}
          >
            {src ? (
              <img
                src={src}
                alt={item.shooting_date}
                style={{ marginRight: 10, maxWidth: '100%', maxHeight: 250 }}
              />
            ) : (
              <CircularProgress />
            )}
          </div>

          <div style={{ width: isSmDownScreen ? '60%' : '100%' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column',
                paddingLeft: 10
              }}
            >
              <span
                style={{
                  width: isSmDownScreen ? '20%' : '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                日付
              </span>
              <div
                style={{
                  width: isSmDownScreen ? '80%' : '100%',
                  padding: '5px 0'
                }}
              >
                <input
                  type='date'
                  style={{ height: 35, width: isSmDownScreen ? '90%' : '100%' }}
                  value={item.shooting_date}
                  {...register(`pictures.${index}.shooting_date`, {
                    required: {
                      value: true,
                      message: '日付は必須です。'
                    }
                  })}
                />
                {errors.pictures && errors.pictures[index]?.shooting_date && (
                  <div style={{ fontSize: 12, color: 'red' }}>
                    {errors.pictures[index].shooting_date.message}
                  </div>
                )}
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column',
                paddingLeft: 10
              }}
            >
              <span
                style={{
                  width: isSmDownScreen ? '20%' : '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                場所
              </span>
              <div
                style={{
                  width: isSmDownScreen ? '80%' : '100%',
                  padding: '5px 0'
                }}
              >
                <input
                  type='text'
                  style={{ width: '100%', height: 35 }}
                  {...register(`pictures.${index}.place`, {
                    maxLength: {
                      value: 50,
                      message: '場所は50文字以内で入力してください。'
                    }
                  })}
                />
                {errors.pictures && errors.pictures[index]?.place && (
                  <div style={{ fontSize: 12, color: 'red' }}>
                    {errors.pictures[index].place.message}
                  </div>
                )}
              </div>
              <span
                style={{
                  width: 20,
                  marginLeft: 10,
                  display: 'flex',
                  alignItems: 'center'
                }}
              ></span>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column',
                paddingLeft: 10
              }}
            >
              <span
                style={{
                  width: isSmDownScreen ? '20%' : '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                備考
              </span>
              <div
                style={{
                  width: isSmDownScreen ? '80%' : '100%',
                  padding: '5px 0'
                }}
              >
                <textarea
                  type='text'
                  style={{ width: '100%', height: 140, maxHeight: 200 }}
                  {...register(`pictures.${index}.note`, {
                    maxLength: {
                      value: 300,
                      message: '備考は300文字以内で入力してください。'
                    }
                  })}
                />
                {errors.pictures && errors.pictures[index]?.note && (
                  <div style={{ fontSize: 12, color: 'red' }}>
                    {errors.pictures[index].note.message}
                  </div>
                )}
              </div>
              <span
                style={{
                  width: 20,
                  marginLeft: 10,
                  display: 'flex',
                  alignItems: 'center'
                }}
              ></span>
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end'
              }}
            >
              <Button
                style={{
                  backgroundColor: '#52555F',
                  color: '#fff',
                  marginRight: 10,
                  margin: '0 0 0 auto',
                  fontSize: 12
                }}
                variant='contained'
                color='secondary'
                onClick={handleRotateClick}
              >
                画像を90度回転
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
